import { useTranslation } from 'react-i18next';
import { CheckCircle2 } from 'lucide-react';
import { Avatar } from '@components/avatar';
import { Button } from '@components/ui/button';
import { ActionSheet } from '@components/scheduling/actionSheet';
import { PhoneConflictsSheetProps } from './types';

export const PhoneConflictsSheet = ({
  open,
  onDismiss,
  items,
  onSendAnyway,
  locked,
}: PhoneConflictsSheetProps) => {
  const { t } = useTranslation('app');

  return (
    <ActionSheet
      open={open}
      onDismiss={onDismiss}
      title={
        items.length ? (
          t('scheduling.phone.conflicts', { count: items.length })
        ) : (
          <span className="flex items-center gap-2 text-primary-600">
            <CheckCircle2 className="h-5 w-5 shrink-0" />
            {t('scheduling.phone.noConflictsLeft')}
          </span>
        )
      }
      actions={
        onSendAnyway ? (
          <div>
            <Button variant="secondary" onClick={onDismiss}>
              {t('scheduling.phone.goBack')}
            </Button>
            <Button disabled={locked} onClick={onSendAnyway}>
              {t(items.length ? 'scheduling.phone.sendAnyway' : 'scheduling.phone.send')}
            </Button>
          </div>
        ) : (
          <div className="!grid-cols-1">
            <Button variant="secondary" onClick={onDismiss}>
              {t('actions.close')}
            </Button>
          </div>
        )
      }>
      <div className="flex flex-col gap-2 pr-3">
        {items.map((item) => (
          <div
            key={item.key}
            className="flex flex-col gap-1.5 rounded-lg border border-neutral-200 p-2.5">
            <div className="flex items-center gap-2.5">
              <Avatar name={item.name} hideTooltip className="h-8 w-8 text-sm" />
              <span className="min-w-0 flex-1 truncate text-[15px] font-semibold text-neutral-700">
                {item.name}
              </span>
              {item.onSwap && (
                <Button variant="secondary" className="h-9 px-3 text-xs" onClick={item.onSwap}>
                  {t('scheduling.phone.swap')}
                </Button>
              )}
            </div>
            {item.lines.map((line) => (
              <div
                key={line.key}
                className="flex flex-col rounded-md border border-warning-200 bg-warning-50 px-2.5 py-1.5 text-xs leading-tight text-neutral-800">
                <span className="font-bold">{line.when}</span>
                <span className="font-medium">{line.text}</span>
              </div>
            ))}
          </div>
        ))}
      </div>
    </ActionSheet>
  );
};
